import * as React from "react";

import TableRow from "@mui/material/TableRow";
import { useTranslation } from "next-i18next";

import { withStyles, makeStyles } from "@material-ui/core/styles";
import { useState } from "react";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import { useRouter } from "next/router";

function createData(name, [calories, fat, carbs, protein], ali) {
  return { name, calories, fat, carbs, protein, ali };
}
const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  tableRow: {
    height: 20,
    paddingLeft: "32px",
    paddingRight: "32px",
  },
  tableCell: {
    padding: "0px 10px",
  },
});
const StyledTableRow = withStyles((theme) => ({
  root: {
    height: 20,
  },
}))(TableRow);

export default function CoimexPriceCardMobile(props) {
  const { t, i18n } = useTranslation();
  const router = useRouter();
  const classes = useStyles();
  const [rowsData, setRowsData] = useState([]);
  const type = router.query.package;
  const que = type === "importer" ? t("Price.10") : t("Price.11");
  const offer = type === "importer" ? t("Price.24") : t("Price.8");
  const productSupport = (data) =>
    props.data.map((item, key) =>
      item.duration.type === props.value ? item?.quota.newSupport[data] : null
    );

  const [openRows, setOpenRows] = useState({});

  const toggleRow = (rowName) => {
    setOpenRows((prev) => ({ ...prev, [rowName]: !prev[rowName] }));
  };

  const product = (data) =>
    props.data.map((item, key) =>
      item.duration.type === props.value
        ? data === "posts"
          ? item?.quotaText.posts
          : item?.quota[data]
        : null
    );

  const rowsExporter = [
    createData(
      t("Price.9"),
      product("categories").filter((item) => item),
      t("Price.36")
    ),

    createData(
      offer,
      product("posts").filter((item) => item),
      t("Price.37")
    ),

    createData(
      que,
      product("replyingProductPostsMessages").filter((item) => item),
      t("Price.38")
    ),

    createData(
      t("Price.12"),
      product("regionsAndCountries").filter((item) => item),
      t("Price.39")
    ),

    createData(
      t("Price.13"),
      product("instantOpportunityNotifications").filter((item) => item),
      t("Price.40")
    ),

    createData(
      t("Price.14"),
      product("coiwallAccess").filter((item) => item),
      t("Price.41")
    ),

    createData(
      t("Price.15"),
      product("nonMemberTrustVerification"),
      t("Price.42")
    ),
  ];
  const rowsImporter = [
    createData(
      t("Price.9"),
      product("categories").filter((item) => item),
      t("Price.28")
    ),

    createData(
      offer,
      product("posts").filter((item) => item),
      t("Price.29")
    ),
    //
    createData(
      t("Price.26"),
      product("messagingProductPosts").filter((item) => item),
      t("Price.30")
    ),
    createData(
      que,
      product("replyingProductPostsMessages").filter((item) => item),
      t("Price.31")
    ),

    createData(
      t("Price.12"),
      product("regionsAndCountries").filter((item) => item),
      t("Price.32")
    ),

    createData(
      t("Price.13"),
      product("instantOpportunityNotifications").filter((item) => item),
      t("Price.33")
    ),

    createData(
      t("Price.14"),
      product("coiwallAccess").filter((item) => item),
      t("Price.34")
    ),

    createData(
      t("Price.15"),
      product("nonMemberTrustVerification"),
      t("Price.35")
    ),
  ];
  const rowsBoth = [
    createData(
      t("Price.9"),
      product("categories").filter((item) => item),
      t("Price.43")
    ),
    createData(
      t("Price.26"),
      product("messagingProductPosts").filter((item) => item),
      t("Price.46")
    ),
    createData(
      t("Price.24"),
      product("posts").filter((item) => item),
      t("Price.45")
    ),
    createData(
      t("Price.8"),
      product("posts").filter((item) => item),
      t("Price.43")
    ),

    createData(
      t("Price.10"),
      product("replyingProductPostsMessages").filter((item) => item),
      t("Price.47")
    ),
    createData(
      t("Price.11"),
      product("replyingProductPostsMessages").filter((item) => item),
      t("Price.44")
    ),
    createData(
      t("Price.12"),
      product("regionsAndCountries").filter((item) => item),
      t("Price.48")
    ),
    createData(
      t("Price.13"),
      product("instantOpportunityNotifications").filter((item) => item),
      t("Price.49")
    ),

    createData(
      t("Price.14"),
      product("coiwallAccess").filter((item) => item),
      t("Price.50")
    ),
    createData(
      t("Price.15"),
      product("nonMemberTrustVerification").filter((item) => item),
      t("Price.51")
    ),
  ];

  const rowsNewExporter = [
    createData(
      t("NewPrice.20"),
      product("tradeGuarantee").filter((item) => item),
      t("Price.43")
    ),

    createData(
      t("NewPrice.21"),
      product("productCategory").filter((item) => item),
      t("Price.30")
    ),

    createData(
      t("NewPrice.22"),
      product("escrowSafePaymentFees").filter((item) => item),
      t("Price.32")
    ),
    createData(
      t("NewPrice.23"),
      product("promptPayAssurance").filter((item) => item != null),
      t("Price.43")
    ),

    createData(
      t("NewPrice.24"),
      product("systemUsage").filter((item) => item),
      t("Price.33")
    ),
  ];
  const rowsNewImporter = [
    createData(
      t("NewPrice.20"),
      product("tradeGuarantee").filter((item) => item),
      t("Price.43")
    ),

    createData(
      t("NewPrice.21"),
      product("productCategory").filter((item) => item),
      t("Price.30")
    ),

    createData(
      t("NewPrice.22"),
      product("escrowSafePaymentFees").filter((item) => item),
      t("Price.32")
    ),

    createData(
      t("NewPrice.24"),
      product("systemUsage").filter((item) => item),
      t("Price.33")
    ),
  ];

  const rowsNewBoth = [
    createData(
      t("NewPrice.20"),
      product("tradeGuarantee").filter((item) => item),
      t("Price.43")
    ),
    createData(
      t("NewPrice.21"),
      product("productCategory").filter((item) => item),
      t("Price.46")
    ),
    createData(
      t("NewPrice.22"),
      product("escrowSafePaymentFees").filter((item) => item),
      t("Price.45")
    ),
    createData(
      t("NewPrice.23"),
      product("promptPayAssurance").filter((item) => item !== null),
      t("Price.43")
    ),

    createData(
      t("NewPrice.24"),
      product("systemUsage").filter((item) => item),
      t("Price.47")
    ),
  ];
  const offerSupport = type === "importer" ? t("Price.25") : t("Price.18");
  const SupportDef = [
    createData(
      t("NewPrice.26"),
      productSupport("matchmakingAndDealSupport").filter((item) => item != null)
    ),
    createData(
      t("NewPrice.27"),
      productSupport("nonMemberVerification").filter((item) => item != null)
    ),
    createData(
      t("NewPrice.28"),
      productSupport("opportunityAndPostSupport").filter((item) => item != null)
    ),
    createData(
      t("NewPrice.29"),
      productSupport("tradeShowMetingSupport").filter((item) => item != null)
    ),
    createData(
      t("NewPrice.30"),
      productSupport("marketingSupport").filter((item) => item != null)
    ),
    createData(
      t("NewPrice.31"),
      productSupport("strategicSupport").filter((item) => item != null)
    ),
    // createData('Customer Acquisition Guarantee', productSupport("COIWALL").filter((item)=>item!= null)),
  ];
  const Supportexport = [
    createData(
      t("NewPrice.26"),
      productSupport("matchmakingAndDealSupport").filter((item) => item != null)
    ),
    createData(
      t("NewPrice.27"),
      productSupport("nonMemberVerification").filter((item) => item != null)
    ),
    createData(
      t("NewPrice.28"),
      productSupport("opportunityAndPostSupport").filter((item) => item != null)
    ),
    createData(
      t("NewPrice.29"),
      productSupport("tradeShowMetingSupport").filter((item) => item != null)
    ),
    createData(
      t("NewPrice.30"),
      productSupport("marketingSupport").filter((item) => item != null)
    ),
    createData(
      t("NewPrice.31"),
      productSupport("strategicSupport").filter((item) => item != null)
    ),
  ];
  const SupportBoth = [
    createData(
      t("Price.16"),
      productSupport("technical").filter((item) => item != null)
    ),
    createData(
      t("Price.17"),
      productSupport("dealNegotiation").filter((item) => item != null)
    ),
    createData(
      t("Price.18"),
      productSupport("productPost").filter((item) => item != null)
    ),
    createData(
      t("Price.25"),
      productSupport("productPost").filter((item) => item != null)
    ),
    createData(
      t("Price.19"),
      productSupport("coiwall").filter((item) => item != null)
    ),
    createData(
      t("Price.20"),
      productSupport("marketing").filter((item) => item != null)
    ),
    createData(
      t("Price.21"),
      productSupport("strategicForeignTrade").filter((item) => item != null)
    ),
    // createData('Customer Acquisition Guarantee', productSupport("COIWALL").filter((item)=>item!= null)),
  ];

  const NewSupportBoth = [
    createData(
      t("NewPrice.26"),
      productSupport("matchmakingAndDealSupport").filter((item) => item != null)
    ),
    createData(
      t("NewPrice.27"),
      productSupport("nonMemberVerification").filter((item) => item != null)
    ),
    createData(
      t("NewPrice.28"),
      productSupport("opportunityAndPostSupport").filter((item) => item != null)
    ),
    createData(
      t("NewPrice.29"),
      productSupport("tradeShowMetingSupport").filter((item) => item != null)
    ),
    createData(
      t("NewPrice.30"),
      productSupport("marketingSupport").filter((item) => item != null)
    ),
    createData(
      t("NewPrice.31"),
      productSupport("strategicSupport").filter((item) => item != null)
    ),
    // createData(
    //   t("Price.21"),
    //   productSupport("strategicForeignTrade").filter((item) => item != null)
    // ),
    // createData('Customer Acquisition Guarantee', productSupport("COIWALL").filter((item)=>item!= null)),
  ];
  function handleType() {
    switch (type) {
      case "importer":
        return rowsNewImporter;
      case "exporter":
        return rowsNewExporter;
      default:
        return rowsNewBoth;
    }
  }
  function handleSupport() {
    switch (type) {
      case "importer":
        return SupportDef;
      case "exporter":
        return Supportexport;
      default:
        return NewSupportBoth;
    }
  }
  const rows = handleType();
  const Support = handleSupport();

  const pricingTiers = [
    { label: "Freemium", key: "calories" },
    { label: "Starter", key: "fat" },
    { label: "Growth", key: "carbs" },
    { label: "Scale", key: "protein" },
  ];
  return (
    <div className=" bg-[#F4EFF4] md:hidden">
      {rows.map((row) => (
        <div
          key={row.name}
          className="w-full rounded-b-[8px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] bg-[#FFFBFE] mb-[10px] "
        >
          <div
            className={`${
              openRows[row.name] ? "" : "h-[64px] flex items-center"
            }  bg-[#D7DAE3] px-[19px]`}
          >
            <div className=" flex justify-between items-center w-full">
              <h4 className="text-[#38466D] text-xl font-bold ">{row.name}</h4>
              <button onClick={() => toggleRow(row.name)}>
                {openRows[row.name] ? <CollapseUpSVG /> : <CollapseDownSVG />}
              </button>
            </div>
            {openRows[row.name] && (
              <p className="text-[#38466D] text-base font-normal mt-2">
                {t("NewPrice.32")}
              </p>
            )}
          </div>
          <div className="px-[19px] pt-[19px] pb-[30px]">
            {type === "importer" ? (
              <>
                <div className="flex items-center justify-between">
                  <p className="text-[#38466D] text-base font-montserrat">
                    {t("Price.Freemium")}{" "}
                  </p>
                  <div className="text-[#38466D] text-base font-montserrat  ">
                    {typeof row.calories === "boolean" ? (
                      <ComSvg bol={row.calories} />
                    ) : (
                      <ComTxt text={row.calories} />
                    )}{" "}
                    {row.name === t("NewPrice.21") ? (
                      t("NewPrice.39")
                    ) : row.name === t("NewPrice.22") ? (
                      <>{t("NewPrice.37")}</>
                    ) : row.name === t("NewPrice.24") ? (
                      t("NewPrice.36")
                    ) : null}
                  </div>
                </div>
                <div className="flex items-center justify-between">
                  <p className="text-[#38466D] text-base font-montserrat">
                    {t("Price.Starter")}{" "}
                  </p>
                  <div className="text-[#38466D] text-base font-montserrat ">
                    {typeof row.fat === "boolean" ? (
                      <ComSvg bol={row.fat} />
                    ) : (
                      <ComTxt text={row.fat} />
                    )}{" "}
                    {""}
                    {row.name === t("NewPrice.21") ? (
                      t("NewPrice.39")
                    ) : row.name === t("NewPrice.22") ? (
                      <>{t("NewPrice.37")}</>
                    ) : row.name === t("NewPrice.24") ? (
                      t("NewPrice.36")
                    ) : null}
                  </div>
                </div>
                <div className="flex items-center justify-between">
                  <p className="text-[#38466D] text-base font-montserrat">
                    {t("Price.Growth")}{" "}
                  </p>
                  <div className="text-[#38466D] text-base font-montserrat ">
                    {typeof row.carbs === "boolean" ? (
                      <ComSvg bol={row.carbs} />
                    ) : (
                      <ComTxt text={row.carbs} />
                    )}{" "}
                    {row.name === t("NewPrice.21") ? (
                      t("NewPrice.39")
                    ) : row.name === t("NewPrice.22") ? (
                      <>{t("NewPrice.37")}</>
                    ) : row.name === t("NewPrice.24") ? (
                      t("NewPrice.36")
                    ) : null}
                  </div>
                </div>
                <div className="flex items-center justify-between">
                  <p className="text-[#38466D] text-base font-montserrat">
                    {t("Price.Scale")}{" "}
                  </p>
                  {row.protein && (
                    <div className="text-[#38466D] text-base font-montserrat">
                      {typeof row.protein === "boolean" ? (
                        <ComSvg bol={row.protein} />
                      ) : (
                        <ComTxt t={t} text={row.protein} />
                      )}{" "}
                      {row.name === t("NewPrice.21") ? (
                        t("NewPrice.39")
                      ) : row.name === t("NewPrice.22") ? (
                        <>{t("NewPrice.37")}</>
                      ) : row.name === t("NewPrice.24") ? (
                        t("NewPrice.36")
                      ) : null}
                      {row.name === t("NewPrice.23") && (
                        <p className="text-[#38466D] text-sm font-montserrat">
                          {t("NewPrice.40")}
                        </p>
                      )}
                    </div>
                  )}
                </div>
              </>
            ) : (
              <>
                <div className="flex items-center justify-between">
                  <p className="text-[#38466D] text-base font-montserrat">
                    {t("Price.Starter")}{" "}
                  </p>
                  <div className="text-[#38466D] text-base font-montserrat  ">
                    {typeof row.calories === "boolean" ? (
                      <ComSvg bol={row.calories} />
                    ) : (
                      <ComTxt text={row.calories} />
                    )}{" "}
                    {row.name === t("NewPrice.21") ? (
                      t("NewPrice.39")
                    ) : row.name === t("NewPrice.22") ? (
                      <>{t("NewPrice.37")}</>
                    ) : row.name === t("NewPrice.24") ? (
                      t("NewPrice.36")
                    ) : null}
                  </div>
                </div>
                <div className="flex items-center justify-between">
                  <p className="text-[#38466D] text-base font-montserrat">
                    {t("Price.Growth")}{" "}
                  </p>
                  <div className="text-[#38466D] text-base font-montserrat ">
                    {typeof row.fat === "boolean" ? (
                      <ComSvg bol={row.fat} />
                    ) : (
                      <ComTxt text={row.fat} />
                    )}{" "}
                    {""}
                    {row.name === t("NewPrice.21") ? (
                      t("NewPrice.39")
                    ) : row.name === t("NewPrice.22") ? (
                      <>{t("NewPrice.37")}</>
                    ) : row.name === t("NewPrice.24") ? (
                      t("NewPrice.36")
                    ) : null}
                  </div>
                </div>
                <div className="flex items-center justify-between">
                  <p className="text-[#38466D] text-base font-montserrat">
                    {t("Price.Scale")}{" "}
                  </p>
                  <div className="text-[#38466D] text-base font-montserrat ">
                    {typeof row.carbs === "boolean" ? (
                      <ComSvg bol={row.carbs} />
                    ) : (
                      <ComTxt text={row.carbs} />
                    )}{" "}
                    {row.name === t("NewPrice.21") ? (
                      t("NewPrice.39")
                    ) : row.name === t("NewPrice.22") ? (
                      <>{t("NewPrice.37")}</>
                    ) : row.name === t("NewPrice.24") ? (
                      t("NewPrice.36")
                    ) : null}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      ))}
      <p className="text-[#38466D] w-full text-xl font-MontserratBold whitespace-nowrap text-center">
        {t("Price.22")}
      </p>
      {Support.map((row) => (
        <div
          key={row.name}
          className="w-full rounded-b-md shadow-lg bg-[#FFFBFE] mb-[10px]"
        >
          <div
            className={`${
              openRows[row.name] ? "" : "pt-[19px] pb-[13px] flex items-center"
            }  bg-[#D7DAE3] px-[19px]`}
          >
            <div className=" flex justify-between items-center w-full">
              <h4 className="text-[#38466D] text-xl font-bold ">{row.name}</h4>
              <button onClick={() => toggleRow(row.name)}>
                {openRows[row.name] ? <CollapseUpSVG /> : <CollapseDownSVG />}
              </button>
            </div>
            {openRows[row.name] && (
              <p className="text-[#38466D] text-base font-normal mt-2">
                {t("NewPrice.32")}
              </p>
            )}
          </div>
          <div className="px-[19px] pt-[19px] pb-[30px]">
            {type === "importer" ? (
              <>
                <div className="flex items-center justify-between">
                  <p className="text-[#38466D] text-base font-montserrat">
                    Freemium{" "}
                  </p>

                  <div className="text-[#38466D] text-base font-montserrat flex items-center justify-between">
                    {typeof row.calories === "boolean" ? (
                      <ComSvg bol={row.calories} />
                    ) : (
                      row.calories
                    )}
                  </div>
                </div>

                <div className="flex items-center justify-between">
                  <p className="text-[#38466D] text-base font-montserrat">
                    Starter{" "}
                  </p>
                  <div className="text-[#38466D] text-base font-montserrat flex items-center justify-between">
                    {typeof row.fat === "boolean" ? (
                      <ComSvg bol={row.fat} />
                    ) : (
                      row.fat
                    )}
                  </div>
                </div>
                <div className="flex items-center justify-between">
                  <p className="text-[#38466D] text-base font-montserrat">
                    Growth{" "}
                  </p>
                  <div className="text-[#38466D] text-base font-montserrat flex items-center justify-between">
                    {typeof row.carbs === "boolean" ? (
                      <ComSvg bol={row.carbs} />
                    ) : (
                      row.carbs
                    )}
                  </div>
                </div>
                <div className="flex items-center justify-between">
                  <p className="text-[#38466D] text-base font-montserrat">
                    Scale{" "}
                  </p>
                  <div className="text-[#38466D] text-base font-montserrat flex items-center justify-between">
                    {typeof row.protein === "boolean" ? (
                      <ComSvg bol={row.protein} />
                    ) : (
                      row.protein
                    )}
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="flex items-center justify-between">
                  <p className="text-[#38466D] text-base font-montserrat">
                    Starter{" "}
                  </p>

                  <div className="text-[#38466D] text-base font-montserrat flex items-center justify-between">
                    {typeof row.calories === "boolean" ? (
                      <ComSvg bol={row.calories} />
                    ) : (
                      row.calories
                    )}
                  </div>
                </div>

                <div className="flex items-center justify-between">
                  <p className="text-[#38466D] text-base font-montserrat">
                    Growth{" "}
                  </p>
                  <div className="text-[#38466D] text-base font-montserrat flex items-center justify-between">
                    {typeof row.fat === "boolean" ? (
                      <ComSvg bol={row.fat} />
                    ) : (
                      row.fat
                    )}
                  </div>
                </div>
                <div className="flex items-center justify-between">
                  <p className="text-[#38466D] text-base font-montserrat">
                    Scale{" "}
                  </p>
                  <div className="text-[#38466D] text-base font-montserrat flex items-center justify-between">
                    {typeof row.carbs === "boolean" ? (
                      <ComSvg bol={row.carbs} />
                    ) : (
                      row.carbs
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

const ComSvg = ({ bol }) => {
  return bol ? <SvgTck /> : <SvgNon />;
};
const ComTxt = ({ text }) => {
  const { t } = useTranslation();

  function bol() {
    if (typeof text === "string") {
      if (text.includes("week")) {
        return text.replace("week", t(`Price.week`));
      } else if (text.includes("month")) {
        return text.replace("month", t(`Price.month`));
      }
      return t(`Price.${text}`);
    } else {
      return text;
    }
  }

  return isNaN(text) && !bol() ? t(`Price.${text}`) : bol();
};
const SvgTck = () => (
  <svg
    className="m-auto"
    width="19"
    height="12"
    viewBox="0 0 19 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.3749 0.839371C18.534 0.95786 18.6295 1.12358 18.6405 1.3001C18.6514 1.47662 18.5768 1.64949 18.4332 1.7807L7.63258 11.6214L1.10176 6.48204C0.955117 6.35848 0.872417 6.1928 0.871109 6.01995C0.869802 5.84709 0.949988 5.68057 1.09475 5.55552C1.23952 5.43047 1.43754 5.35666 1.64705 5.34967C1.85656 5.34267 2.06117 5.40304 2.21773 5.51804L7.54686 9.71137L17.2339 0.886704C17.3052 0.821759 17.3913 0.769031 17.4873 0.731535C17.5834 0.694038 17.6874 0.672509 17.7935 0.668175C17.8996 0.663841 18.0057 0.676788 18.1058 0.706277C18.2058 0.735767 18.2978 0.781219 18.3766 0.840037L18.3749 0.839371Z"
      fill="#38466D"
      stroke="#38466D"
      strokeWidth="0.5"
    />
  </svg>
);

const SvgNon = () => (
  <svg
    className="m-auto"
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.75294 6.00003L12.0528 10.3692M1.45312 10.3692L6.75294 6.00003L1.45312 10.3692ZM12.0528 1.63086L6.75193 6.00003L12.0528 1.63086ZM6.75193 6.00003L1.45312 1.63086L6.75193 6.00003Z"
      stroke="#38466D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CoimexTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#8791A7",
    color: "#fff",
    maxWidth: 250,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}));

const CollapseUpSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="8"
    viewBox="0 0 14 8"
    fill="none"
  >
    <path
      d="M13 7L7 1L1 7"
      stroke="#38466D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CollapseDownSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="8"
    viewBox="0 0 14 8"
    fill="none"
  >
    <path
      opacity="0.7"
      d="M1 1L7 7L13 1"
      stroke="#38466D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
